<template>
  <div>
    <div class="base-input-text__label">
      {{ label }}
    </div>
    <div
      v-if="!editMode"
      :class="`base-input-text__input__container ${!readonly ? 'base-input-text--editable' : ''}`"
      @click="startEditing"
    >
      <template v-if="!innerValue.day">
        <base-icon
          v-if="!readonly"
          icon="plus"
          class="mr-2"
        /> <span
          v-if="!readonly"
          class="base-input-text__placeholder"
        >
          {{ placeholder }}
        </span>
      </template>

      <template v-else>
        <span class="base-input-text__placeholder">
          <slot :value="innerValue">
            {{ value | nicedate('small') }}
          </slot>
        </span>
      </template>
    </div>
    <div v-if="editMode">
      <div class="d-flex">
        <input
          ref="month"
          v-model.trim.lazy="innerValue.month"
          class="base-input-text__input"
          type="number"
          max="12"
          placeholder="MM"
          tabindex="1"
          @keypress.enter="stopEditing"
          @blur="onBlur"
          @focus="isFocused = true"
        >
        <input
          ref="day"
          v-model.trim.lazy="innerValue.day"
          class="base-input-text__input"
          placeholder="DD"
          type="number"
          max="31"
          tabindex="2"
          @keypress.enter="stopEditing"
          @blur="onBlur"
          @focus="isFocused = true"
        >
        <input
          ref="year"
          v-model.trim.lazy="innerValue.year"
          class="base-input-text__input"
          type="number"
          placeholder="YYYY"
          tabindex="3"
          @keypress.enter="stopEditing"
          @blur="onBlur"
          @focus="isFocused = true"
        >
        <base-icon
          class="ml-2"
          icon="check"
          @click="stopEditing"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateEditor',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Birthday',
    },
    placeholder: {
      type: String,
      default: 'Add birthday',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
      editMode: false,
      innerValue: {},
    };
  },
  watch: {
    'innerValue.day': {
      handler(evt) {
        if (!evt) {
          this.innerValue.day = null;
          return;
        }
        if (evt > 31) {
          this.innerValue.day = 31;
        }
        if (evt < 1) {
          this.innerValue.day = 1;
        }
      },
    },
    'innerValue.month': {
      handler(evt) {
        if (!evt) {
          this.innerValue.month = null;
          return;
        }
        if (evt > 12) {
          this.innerValue.month = 12;
        }
        if (evt < 1) {
          this.innerValue.month = 1;
        }
      },
      'innerValue.year': {
        handler(evt) {
          if (!evt) {
            this.innerValue.year = null;
          }
        },
      },
    },
    value: {
      handler(val) {
        const date = this.$moment(val);

        if (date.isValid()) {
          this.innerValue = {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;
      setTimeout(() => {
        if (!this.isFocused) {
          this.stopEditing();
        }
      }, 100);
    },
    startEditing() {
      if (this.readonly) return;
      this.editMode = true;
      this.$nextTick().then(() => {
        this.$refs.month.focus();
      });
    },
    stopEditing() {
      this.editMode = false;
      const canSendUpdate = (this.isFocused === this.editMode); // This prevents double updating
      if (canSendUpdate) {
        this.$emit('input', this.innerValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-input-text {
    &--editable{
        cursor: pointer;
    }
    &__label {
        font-family: $font-family-sans-serif-light;
        font-style: normal;
        font-weight: normal;
        font-size: 0.75rem;
        line-height: 14px;
        letter-spacing: 0.105px;
        text-transform: uppercase;
        color: #AAAAAA;
        height: 20px;
        display: flex;
        align-items: center;
    }
    &__input__container {
        height: 28px;
        display: flex;
        align-items: center;
    }
    &__input {
        width: 100%;
    }
    &__input + &__input {
        margin-left: 3px;
    }
    &__placeholder{
      font-family: $font-family-sans-serif-regular;
      font-size: 0.875rem;
      line-height: 16px;
    }
}
</style>
